{
    "picker__title": "Zeitraum",
    "option__today": "Heute",
    "option__yesterday": "Gestern",
    "option__last_week": "Letzte Woche",
    "option__last_month": "Letzter Monat",
    "option__last_quarter": "Letzte 3 Monate",
    "option__ttm": "Letzte 12 Monate",
    "option__ytd": "Laufendes Jahr",
    "option__full_year": "Volles Jahr",
    "option__custom": "Benutzerdefiniert"
}
